export default __webpack_public_path__ + "static/expert-3-bb81df945c71f1b7f97276138305a4c6.png";